<!-- This drawer opens when you click on the 'View more details' button on a single row in the Upload History Table -->
<template>
  <div id="upload-details-drawer">
    <div
      v-if="item"
      class="bg-light"
    >
      <b-table
        small
        borderless
        :items="flatFields"
        :fields="fields"
        class="mb-2 bg-light"
        head-variant="light"
        thead-class="d-none"
        responsive
      >
        <template #cell(key)="data">
          <strong
            class="text-nowrap"
          >
            {{ formatLabel(data.item.key) }}
          </strong>
        </template>
        <template #cell(value)="data">
          <span class="text-sm">{{ data.item.value }}</span>
        </template>
      </b-table>

      <div class="mb-2 text-sm">
        <div class="pl-1">
          <strong>Result Set</strong>
        </div>
        <div v-if="fullUploadData?.ResultSetTemp?.length > 0">
          <pre class="bg-secondary text-white p-2 rounded boxes">
      {{ fullUploadData.ResultSetTemp }}
        </pre>
        </div>
        <div
          v-else
          class="pl-1"
        >
          {{ fullUploadData.ResultSetTemp }}
        </div>
      </div>

      <div class="mb-2 text-sm">
        <div class="pl-1">
          <strong>Warnings</strong>
        </div>
        <div v-if="fullUploadData?.Warnings?.length > 0">
          <pre class="bg-dark text-white p-2 rounded boxes">{{ JSON.stringify(fullUploadData.Warnings, null, 2) }}</pre>
        </div>
        <div
          v-else
          class="pl-1"
        >
          {{ fullUploadData.Warnings }}
        </div>
      </div>

      <div class="mb-2 text-sm">
        <div class="pl-1">
          <strong>Errors</strong>
        </div>
        <div v-if="fullUploadData?.Errors?.length > 0">
          <pre
            class="bg-dark text-white p-2 rounded boxes"
          >{{ fullUploadData.Errors }}</pre>
        </div>
        <div
          v-else
          class="pl-1"
        >
          {{ fullUploadData.Errors }}
        </div>
      </div>
    </div>
    <content-spinner
      :show="uploadHistoryLoadingState"
      text=""
    />
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '@/core/components/ContentSpinner.vue';

const {
  mapState: uploadHistoryMapState, 
  mapActions: uploadHistoryMapActions,
} = createNamespacedHelpers('dataManagement');

export default {
  name: 'UploadDetailsDrawer',
  components: {
    ContentSpinner,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    columns: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        { key: 'key', label: '', thStyle: { display: 'none' }, tdAttr: { style: 'padding: 0px 5px !important;' }  },
        { key: 'value', label: '', thStyle: { display: 'none' }, tdAttr: { style: 'padding: 0px 5px !important;' }  },
      ],
    };
  },
  computed: {
    ...uploadHistoryMapState({
      fullUploadData: state => state.uploadHistory.fullUploadData,
      uploadHistoryLoadingState: state => state.uploadHistory.loading,
    }),
    flatFields() {
      if (!this.fullUploadData) return [];
      const exclude = ['ResultSetTemp', 'Errors', 'Warnings'];
      return Object.entries(this.fullUploadData)
        .filter(([key, val]) => !exclude.includes(key) && typeof val !== 'object')
        .map(([key, val]) => ({ key, value: val }));
    },
  },
  methods: {
    ...uploadHistoryMapActions(['getFullDataForOneUpload']),
    formatLabel(label) {
      return label.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
    },
  },
  async mounted() {
    await this.getFullDataForOneUpload(this.item.UploadId);
  },
};
</script>

<style lang="css" scoped>
.boxes {
  max-width: 100%;
  overflow-x: auto;
  white-space: pre-wrap;
}
.text-nowrap{
  font-size: 12px;
  width: 75px;
  display: inline-block;
}
.text-sm{
  font-size: 12px;
}
</style>